/* Bhairav Tatva v6 — "Buy now" in the sticky add-to-cart bar, ₹ price in the bar. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const tidyPrice = (bar) => {
    const p = bar.querySelector('.sticky-add-to-cart__price');
    if (!p) return;
    p.querySelectorAll('*').forEach((el) => {
      if (el.children.length) return;
      const t = el.textContent;
      const m = t.match(/Rs\.?\s?([\d,]+)(\.\d+)?/);
      if (!m) return;
      const n = Number(m[1].replace(/,/g, ''));
      const dec = m[2] && m[2] !== '.00' ? m[2] : '';
      el.textContent = t.replace(m[0], `₹${n.toLocaleString('en-IN')}${dec}`);
    });
  };
  const enhance = () => document.querySelectorAll('sticky-add-to-cart').forEach((s) => {
    const bar = s.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    tidyPrice(bar);
    if (bar.querySelector('.bt-sticky-buy')) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'bt-sticky-buy';
    b.textContent = 'Buy now';
    b.addEventListener('click', () => {
      const id = s.dataset.currentVariantId;
      if (!id) return;
      b.disabled = true;
      b.textContent = 'Opening checkout…';
      // Same as "Buy it now": a checkout with just this item; the cart is left as it is.
      window.location.href = `${root}cart/${id}:1`;
    });
    bar.append(b);
    new MutationObserver(() => { if (!bar.querySelector('.bt-sticky-buy')) bar.append(b); tidyPrice(bar); })
      .observe(bar, { childList: true, subtree: true, characterData: true });
  });
  // Our own show/hide rule for the bar: visible whenever the page's own buy buttons are NOT on
  // screen (so on phones it is there from the start, since the buttons sit below the photos),
  // and hidden while the footer is in view. Horizon's own rule only showed it after scrolling past
  // the buttons and hid it again at the end of the product section.
  const watch = () => document.querySelectorAll('sticky-add-to-cart').forEach((s) => {
    const bar = s.querySelector('.sticky-add-to-cart__bar');
    // With the gemstone configurator on the page its box takes the place of the (hidden) buy buttons.
    const main = document.querySelector('.product-information .bt-cfg') || document.querySelector('.product-information .product-form-buttons') || document.querySelector('.product-form-buttons');
    if (!bar || !main || s.dataset.btWatch) return;
    s.dataset.btWatch = '1';
    const foot = document.querySelector('footer, .shopify-section-group-footer-group');
    let shown = null;
    // Keep clear of Shopify's admin preview bar (only shown to the store owner, but it would cover the bar).
    const lift = () => {
      const pb = document.getElementById('PBarNextFrameWrapper');
      const r = pb ? pb.getBoundingClientRect() : null;
      const h = r && r.height > 0 ? Math.max(0, Math.round(window.innerHeight - r.top)) : 0;
      bar.style.setProperty('--bt-lift', `${h}px`);
    };
    // Horizon scrolls inside .page-wrapper on desktop and the window on phones, so listen to
    // every scroll (capture) and measure, rather than relying on one scroll container.
    const check = () => {
      const vh = window.innerHeight;
      const r = main.getBoundingClientRect();
      const mainOnScreen = r.bottom > 0 && r.top < vh - 40;
      // Step aside only once the footer fills the lower half of the screen.
      const footVisible = foot ? foot.getBoundingClientRect().top < vh * 0.5 : false;
      const on = !mainOnScreen && !footVisible;
      if (on === shown) return;
      shown = on;
      lift();
      bar.toggleAttribute('data-bt-show', on);
      document.documentElement.classList.toggle('bt-sticky-on', on);
    };
    document.addEventListener('scroll', check, { capture: true, passive: true });
    window.addEventListener('resize', () => { lift(); check(); });
    if (window.ResizeObserver) {
      const pb = () => document.getElementById('PBarNextFrameWrapper');
      const mo = new MutationObserver(() => { if (pb()) { new ResizeObserver(lift).observe(pb()); mo.disconnect(); lift(); } });
      if (pb()) new ResizeObserver(lift).observe(pb()); else mo.observe(document.body, { childList: true });
    }
    window.addEventListener('load', () => { lift(); check(); });
    setTimeout(() => { lift(); check(); }, 1500);
    check();
  });

  window.addEventListener('pageshow', () => document.querySelectorAll('.bt-sticky-buy').forEach((b) => { b.disabled = false; b.textContent = 'Buy now'; }));
  const init = () => { enhance(); watch(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
